// extracted by mini-css-extract-plugin
export default {"container":"Career_container__ZVvYv","h2":"Career_h2__jsJ16","list":"Career_list__JhREP"};